/**
 * 💰 Currency Formatting Utility
 *
 * Formats numbers as Nigerian Naira currency
 */

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0
  }).format(amount || 0);
}
